import PropTypes from 'prop-types';
import Oidc, { User } from 'oidc-client';
import { ElementType } from 'react';
import QueryMember from '../../pages/query-member';
import MvkReservationInfoComponent from '../../pages/mvk-reservation/mvk-reservation-info';

export default class AuthManager {
    static getAccessToken() {
        return this.getUser().access_token;
    }
    static propTypes = {
        prop: PropTypes,
    };
    static user: Oidc.User;

    static authkey = `oidc.user:${process.env.REACT_APP_AUTH_AUTHORITY}:${process.env.REACT_APP_AUTH_CLIENT_ID}`;
    static mgr = new Oidc.UserManager({
        authority: process.env.REACT_APP_AUTH_AUTHORITY,
        client_id: process.env.REACT_APP_AUTH_CLIENT_ID,
        client_secret: process.env.REACT_APP_AUTH_CLIENT_SECRET,
        response_type: 'code',
        scope: 'thirdparty profile openid',
        redirect_uri: process.env.REACT_APP_PUBLIC_URL + 'callback',
        post_logout_redirect_uri: process.env.REACT_APP_PUBLIC_URL + 'logged-out',
        loadUserInfo: true,
        automaticSilentRenew: false,
        monitorSession: true,
        revokeAccessTokenOnSignout: false,
        checkSessionInterval: 20000,
        stopCheckSessionOnError: true,
        validateSubOnSilentRenew: true,
    });
    static login = async () => {
        let user = await this.mgr.getUser();
        if (user === null || user.expired) {
            window?.sessionStorage?.clear();
            await this.mgr.signinRedirect();
            return;
        }
    };
    static isLoggedIn = () => {
        try {
            let user = this.getUser();
            let isExpired = true;
            if (user != null) {
                let expires_in = parseInt(user.expires_at);
                if (expires_in > 0) {
                    let now = parseInt((Date.now() / 1000).toString());
                    isExpired = expires_in - now <= 0;
                }
            }
            if (isExpired) {
            }
            return !isExpired;
        } catch (e) {
            return false;
        }
    };
    static loggedInCallback = async () => {
        if (!this.isLoggedIn()) {
            var user = await this.mgr.signinRedirectCallback();
            this.mgr.events.addUserSignedOut(async () => {
                await this.mgr.removeUser();
                alert('Çıkış yapıldı.');
                await this.login();
            });
            this.setUser(user);
        }
    };
    static getUserName = () => {
        try {
            return this.getUser().profile.given_name;
        } catch {
            return null;
        }
    };
    static getUserRoles = (): string[] | null => {
        const usr = this.getUser();
        return usr && !usr.expired && usr.profile ? usr.profile.role as string[] : null;
    };
    static getMainPage = (): ElementType => {
        let roles = this.getUserRoles();
        if (roles == null) {
            return QueryMember
        } else if (roles.includes(UserRoles.MvkReservation)) {
            return MvkReservationInfoComponent
        } else {
            return QueryMember
        }
    };
    static logout = () => {
        this.mgr.signoutRedirect();
    };
    static loggedOutCallback = async () => {
        await this.mgr.signoutRedirectCallback();
        await this.mgr.clearStaleState();
        window.sessionStorage.clear();
    };
    private static setUser = (user: Oidc.User) => {
        window.sessionStorage.setItem('_user', JSON.stringify(user));
    };
    private static getUser = () => {
        try {
            return JSON.parse(window?.sessionStorage?.getItem('_user') ?? '');
        } catch {
            return null;
        }
    };
}

export enum UserRoles{
    CirosuzBayi = "KAMP. BAYİ- CİROSUZ",
    MvkReservation = "MVK REZERVASYON YETKİLİSİ"
}